import { useRecordings, useScan } from "../api/recordings";
import { useJobs } from "../api/storage";
import { errorMessage } from "../api/client";
import RecordingGrid from "../components/RecordingGrid";

// In-flight pipeline states + failures — everything that is not yet review-ready.
const PROCESSING_FILTER = "discovered,downloading,validating,processing,failed";

export default function ProcessingPage() {
  const { data, isLoading, error, isFetching } = useRecordings({
    status: PROCESSING_FILTER,
    limit: 200,
  });
  const scan = useScan();
  const jobs = useJobs();
  const counts = jobs.data?.counts ?? {};
  const items = data?.items ?? [];

  return (
    <div className="processing-page">
      <div className="page-head">
        <div>
          <h1 className="page-title">Processing</h1>
          <p className="page-sub">
            {data ? `${items.length} in the pipeline` : "Loading…"}
            {isFetching && !isLoading ? " · refreshing" : ""}
          </p>
        </div>
      </div>

      <section className="card">
        <div className="card-head">
          <h3>Ingestion</h3>
        </div>
        <p className="muted small">
          “Scan storage” looks in object storage for new recording bundles the app uploaded,
          registers each one, and enqueues it for processing. Run it after new recordings are
          uploaded — recordings then move through this page and land in Review when done.
        </p>
        <div className="actions">
          <button className="btn primary" disabled={scan.isPending} onClick={() => scan.mutate({})}>
            {scan.isPending ? "Scanning…" : "Scan storage"}
          </button>
          <span className="muted small">
            Jobs — queued {counts.queued ?? 0} · running {counts.running ?? 0} · failed{" "}
            {counts.failed ?? 0}
          </span>
        </div>
        {scan.isError && <p className="error">Scan failed: {errorMessage(scan.error)}</p>}
        {scan.data && (
          <p className="note">
            Scanned {scan.data.scanned} object(s) · {scan.data.discovered.length} new ·{" "}
            {scan.data.enqueued.length} enqueued · {scan.data.skipped} skipped.
          </p>
        )}
      </section>

      {error && <p className="error">Failed to load recordings: {errorMessage(error)}</p>}

      <RecordingGrid
        items={items}
        isLoading={isLoading}
        emptyText="Nothing processing right now."
        emptyHint="Use “Scan storage” to pull in newly uploaded recordings."
      />
    </div>
  );
}
